<template>
    <transition name="fade">
        <div @click.self="close" class="modal" v-show="show">
            <div class="modal-window">
                <slot v-bind="{open, close}"></slot>
                <div class="footer p-2 text-right border-top">
                    <v-button @click="close" class="mr-2" v-if="cancel" variant="text">{{ cancel }}</v-button>
                    <v-button @click="confirm">{{ ok }}</v-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: "VModal",
    props: {
        show: {
            type: Boolean
        },
        ok: {
            type: String,
            default: "Close"
        },
        cancel: {
            type: [String, Boolean],
            default: "Cancel"
        }
    },
    data() {
        return {
            scrollTop: 0
        };
    },
    watch: {
        show(to) {
            if (to === true) {
                this.open();
            }
        }
    },
    created() {
        this.$root.$on("modal::closeAll", this.close);
        document.body.addEventListener("keyup", this.key);
    },
    mounted() {
        if (this.show) {
            this.open();
        }
    },
    beforeDestroy() {
        this.$emit("update:show", false);
        document.body.removeEventListener("keyup", this.key);
    },
    methods: {
        key(e) {
            if (e.key == "Escape") {
                this.close();
            }
        },
        open() {
            this.scrollTop =
                window.pageYOffset || document.documentElement.scrollTop;
            // TODO: Close all other modals
            // this.$root.$emit("modal::closeAll");

            this.$emit("update:show", true);
            this.$emit("opened");
            this.fixScrollPosition();
        },
        close() {
            this.$emit("update:show", false);
            this.$emit("closed");
            this.fixScrollPosition();
        },
        confirm() {
            if (this.$listeners && this.$listeners.confirm) {
                // If there is a confirm listener let it handle the confirmation
                this.$emit("confirm");
            } else {
                this.close();
            }
        },
        fixScrollPosition() {
            document.documentElement.scrollTop = document.body.scrollTop = this.scrollTop;
            setTimeout(() => {
                document.documentElement.scrollTop = document.body.scrollTop = this.scrollTop;
            }, 1);
        }
    }
};
</script>
<style lang="scss" scoped>
.modal {
    position: fixed;
    top: 0px;
    left: 0px;
    background-color: rgba(0, 0, 0, 0.25);
    backdrop-filter: blur(3px);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
}

.modal-window {
    min-width: 20vw;
    max-width: 50vw;
    max-height: 80vh;
    overflow: auto;
    background-color: $white;
    color: $dark;
}
@media (max-width: #{map-get($grid-breakpoints, "md")}) {
    .modal-window {
        max-width: 70vw;
    }
}
@media (max-width: #{map-get($grid-breakpoints, "sm")}) {
    .modal-window {
        max-width: 90vw;
    }
}
</style>